import(/* webpackMode: "eager" */ "/app/app/pathway/page.tsx");
